import styles from "../../styles/common/BlockTokenPair.module.scss";

import clsx from "clsx";
import {switchToken} from "../../functions/SwitchToken";

interface BlockTokenPairProps {
  extraClassName?: string;
  gridStyle?: "odd" | "even"; //all tokens same size
  tokens?: string[],
  tokenName?: string;
}
function BlockTokenPair(
  {
    extraClassName,
    gridStyle = "odd",
    tokens,
    tokenName
  }: BlockTokenPairProps) {
  return (
    <div
      className={clsx(styles.cBlockTokenPair, "c-block-token-pair", extraClassName && extraClassName)}
      data-style={gridStyle}
    >

      <div className="c-block-token-pair-grid">

        {tokens && tokens.map((token, tokenIdx) => (
          <div
            className="c-block-token-pair-grid-item"
            key={tokenIdx}
            title={`${switchToken(token, "fullName")}`}
          >
            <span>
              {switchToken(token, "image")}
            </span>
          </div>
        ))}

      </div>

      {tokenName && (
        <p>
          {switchToken(tokenName, "name")}
        </p>
      )}

    </div>
  );
}

export default BlockTokenPair;